module.exports = __webpack_public_path__ + "static/Fisheries-01fc9a47dc7eaf5233c6c6ad8ae78b04.jpg";